
<!-- HEADER VISOR -->
<div class="row align-items-center viewer-header" data-tour="menu-documentos">
  <!-- Botón menú -->
  <div class="col-auto">
    <button class="btn icon-circle" (click)="showDocumentMenu()">
      <i class="fa fa-bars fa-solid"></i>
    </button>
  </div>

  <!-- Paginación -->
  <div class="col">
    <div class="viewer-pagination">
      <button class="btn icon-circle" (click)="previousPage()" [disabled]="selectedIndex === 0">
        <i class="fa fa-arrow-left"></i>
      </button>

      <span class="page-indicator">
        {{ selectedIndex + 1 }} / {{ documentData?.length || 0 }}
      </span>

      <button class="btn icon-circle" (click)="nextPage()" [disabled]="selectedIndex === (documentData.length - 1)">
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>

<!-- PANEL LATERAL DE DOCUMENTOS -->
<div class="file-list" *ngIf="diplayListDocuments">
  <div class="menu-panel shadow-sm" [class.show]="diplayListDocuments">
    <div class="menu-header d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0">Documentos</h6>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showDocumentMenu()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="file-items">
      <div *ngFor="let file of documentData; let i = index" class="file-item" [class.selected]="i === selectedIndex"
        (click)="selectFile(file.id)">
        <span class="file-index">{{ i + 1 }}.</span>
        <span class="file-name text-truncate">{{ file.url }}</span>
      </div>
    </div>
  </div>
</div>

<br><br>